import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ApolusTypes } from './apolus-proxy.service';
/* import { ApolusTypes } from './apolus-proxy.service';
 */
@Injectable({
  providedIn: 'root'
})
export class ApolusService {
  
  literals: ApolusTypes.ApolusCommonLiterals = null;
  onSetLiterals: BehaviorSubject<ApolusTypes.ApolusCommonLiterals> = new BehaviorSubject<ApolusTypes.ApolusCommonLiterals>(this.literals);

  constructor() { }

  setLiterals(literals: ApolusTypes.ApolusCommonLiterals) {
    this.literals = literals;
    this.onSetLiterals.next(literals);
  }

  getLiterals(): Observable<ApolusTypes.ApolusCommonLiterals> {
    return of(this.literals);
  } 
}
